<div class="row">
    <p class="col-lg-11 col-md-11"><b>LMP is not entered. Do you want to save?</b></p>
</div>
<div class="row">
    <div class="col-lg-12" style="text-align: center;">
        <button class="btn btn-default" (click)="finalsaveobsthistoryno()">No</button>  &nbsp;&nbsp;&nbsp;&nbsp; <span><button class="btn btn-primary" (click)="finalsaveobsthistoryok()">Yes</button></span>
    </div>
</div>
